import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timeline-chart"
export default class extends Controller {
  static targets = [
    'canvas'
  ]

  static values = {
    labels: String,
    values: String
  }

  connect() {
    let labels = JSON.parse(this.labelsValue)
    let values = JSON.parse(this.valuesValue)

    // primary (blue), yellow, green. See app/assets/stylesheets/_variables.scss
    let colors = ['#34495e', '#f1b70e', '#16a085']

    new Chart(this.canvasTarget.getContext('2d'), {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Adoptions',
          data: values,
          backgroundColor: colors,
          borderColor: colors
        }]
      },
      options: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 20 // Leave room for the count that sits above each bar.
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0 // Adoptions are whole numbers, so don't label the axis with decimals.
            }
          }
        },
        plugins: {
          legend: {
            display: false // The bars are labeled on the x axis, so a single-dataset legend adds nothing.
          },
          datalabels: {
            // Sit the count above the bar rather than inside it, so a milestone with no adoptions
            // yet still shows its zero instead of hiding it in a bar with no height.
            anchor: 'end',
            align: 'end',
            offset: 0,
            color: '#34495e',
            formatter: function(value, context) {
              return value
            }
          }
        }
      }
    })
  }
}
